enum VehicleOwnershipType {
  OWNED,
  RENTED
}

export enum VehicleOwnershipLabelType {
  OWNED = 'Owned',
  RENTED = 'Rented'
}
export default VehicleOwnershipType
